import React from "react";
import {
  Navigate,
} from "react-router-dom";


const ManagerListComponent = React.lazy(() => import("../../../components/manager/components/list/page"));


export const managerRoute = [
  {
      path: 'list',
      element: <ManagerListComponent />,
  },
  {
      path: '',
      element: <Navigate replace to="/manager/list" />
  },
];